
const opLastMove = (history, color) => {
    const l = history.length;

    if (color === 'white') {
        return history[Math.floor(l/2) * 2 - 1];

    }
    else if (color === 'black') {
        if (l % 2 === 0) {
            return history[Math.floor(l/2) * 2 - 2];
        } else {
            return history[Math.floor(l/2) * 2];
        }
    }
    return '';
}

// case odd l > 5
// w >> last index = l - 1
// b >>
// [0, 1, 2, 3, 4]
//  w. b. w. b. w
// [0, 1, 2, 3]
//  w. b. w. b

const myLastMove = (history, color) => {
    const l = history.length;

    if (color === 'white') {
        return history[Math.floor(l/2) * 2 - 2];

    }
    else if (color === 'black') {
        return history[Math.floor(l/2) * 2 - 1];
    }
    return '';
}

export {opLastMove, myLastMove};